import { fetchQuery, graphql } from 'relay-runtime'
import environment from '../../relay/Environment'

const query = graphql`
    query GetDeviceExportQuery($id: ID!) {
        deviceExport(id: $id) {
            id
            file
            fileSize
            error
            done
            createdAt
        }
    }
`

export default id => {
    return fetchQuery(environment, query, { id }).then(res => {
        return Promise.resolve(res.deviceExport)
    })
}
